<section class="loader-wrapper">
    <div class="loader2 loader-7">
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="line line3"></div>
    </div>
</section>